module.exports = "<div class=\"column\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/column.html
// module id = 633
// module chunks = 0